import React from 'react'

import useSession from '@aytm/app/swidget/base/session/useSession'
import useInterfaceLocale from '../../modules/locale/useInterfaceLocale'

import { ActionType, IAction } from '../../actions/types'
import { Button } from 'primereact/button'

import style from './style.module.scss'

export interface ISideTextProps {
  action: IAction
  mobileLayout: boolean
  title?: string
  text?: string
  onClose?: () => void
}

const SideText = React.memo<ISideTextProps>(
  ({ action, mobileLayout, onClose, title, text }) => {
    const session = useSession()

    const { t, localeOptions } = useInterfaceLocale()

    return ActionType.ASK === action.action ? (
      <div className={`${style.SideText}  ${mobileLayout ? style.mobile : ''}`} role="complementary">
        <div className={style.content}>
          {title && <div className={style.title}>{title}</div>}
          <div dangerouslySetInnerHTML={{ __html: text || session.sideText }} />
        </div>
        {'function' == typeof onClose && (
          <div className={style.footer}>
            <Button
              label={t('preview', 'texts', 'next')}
              aria-label={t('preview', 'texts', 'next')}
              onClick={onClose}
              className={`p-button-primary`}
              icon={localeOptions.rtl ? 'pi pi-chevron-left' : 'pi pi-chevron-right'}
              iconPos={localeOptions.rtl ? 'left' : 'right'}
            />
          </div>
        )}
      </div>
    ) : null
  },
  (prevProps, nextProps) =>
    prevProps.action === nextProps.action &&
    prevProps.onClose == nextProps.onClose &&
    prevProps.text == nextProps.text &&
    prevProps.title == nextProps.title
)

SideText.displayName = 'SideText'

export default SideText
